import React from 'react';
import { FiX, FiShoppingCart, FiPlus, FiMinus, FiTrash2 } from 'react-icons/fi';
import { useCart } from '../context/CartContext';
import './CartDrawer.css';

const CartDrawer = () => {
  const {
    cartItems,
    isCartOpen,
    setIsCartOpen,
    removeFromCart,
    updateQuantity,
    totalItems,
    totalPrice,
    clearCart,
    checkoutViaWhatsApp,
  } = useCart();

  return (
    <>
      <div
        className={`cart-backdrop ${isCartOpen ? 'open' : ''}`}
        onClick={() => setIsCartOpen(false)}
        aria-hidden="true"
      />

      <aside className={`cart-drawer ${isCartOpen ? 'open' : ''}`} aria-label="Shopping cart">
        <div className="cart-drawer-header">
          <div className="cart-title-row">
            <FiShoppingCart size={20} />
            <h2 className="cart-title">Your Cart</h2>
            {totalItems > 0 && <span className="cart-count-badge">{totalItems}</span>}
          </div>
          <button
            className="cart-close-btn"
            onClick={() => setIsCartOpen(false)}
            aria-label="Close cart"
          >
            <FiX size={20} />
          </button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-empty">
            <FiShoppingCart size={48} className="cart-empty-icon" />
            <p className="cart-empty-title">Your cart is empty</p>
            <p className="cart-empty-sub">Add some spices to get started</p>
            <button className="cart-continue-btn" onClick={() => setIsCartOpen(false)}>
              Browse Spices
            </button>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map((item) => (
                <div key={item.id} className="cart-item">
                  <div className="cart-item-icon">
                    {item.icon || <FiShoppingCart size={20} />}
                  </div>
                  <div className="cart-item-info">
                    <p className="cart-item-name">{item.name}</p>
                    <p className="cart-item-price">
                      TZS {(item.price * item.quantity).toLocaleString()}
                    </p>
                  </div>
                  <div className="cart-item-controls">
                    <button
                      className="qty-btn"
                      onClick={() => updateQuantity(item.id, item.quantity - 1)}
                      aria-label="Decrease quantity"
                    >
                      <FiMinus size={12} />
                    </button>
                    <span className="qty-value">{item.quantity}</span>
                    <button
                      className="qty-btn"
                      onClick={() => updateQuantity(item.id, item.quantity + 1)}
                      aria-label="Increase quantity"
                    >
                      <FiPlus size={12} />
                    </button>
                    <button
                      className="remove-btn"
                      onClick={() => removeFromCart(item.id)}
                      aria-label={`Remove ${item.name}`}
                    >
                      <FiTrash2 size={14} />
                    </button>
                  </div>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-total-row">
                <span className="cart-total-label">Total</span>
                <span className="cart-total-amount">TZS {totalPrice.toLocaleString()}</span>
              </div>

              <button className="checkout-btn" onClick={checkoutViaWhatsApp}>
                Order via WhatsApp
              </button>

              <button className="clear-cart-btn" onClick={clearCart}>
                Clear cart
              </button>
            </div>
          </>
        )}
      </aside>
    </>
  );
};

export default CartDrawer;
